module.exports = __webpack_public_path__ + "static/media/cert3.66ebc777.png";